import { ref } from 'vue'

export function useWalletActions(store) {
  // --- create ---
  const showCreate = ref(false)
  const busyCreate = ref(false)
  const errMsg = ref('')

  function toggleCreate() {
    showCreate.value = !showCreate.value
    if (!showCreate.value) errMsg.value = ''
  }

  function cancelCreate() {
    showCreate.value = false
    errMsg.value = ''
  }

  async function createWallet(name) {
    if (busyCreate.value) return
    errMsg.value = ''
    busyCreate.value = true
    try {
      await store.createWallet({ name: name || '' })
      showCreate.value = false
    } catch (e) {
      errMsg.value = e?.message || 'wallet_create_failed'
    } finally {
      busyCreate.value = false
    }
  }

  // --- rename ---
  async function renameWallet(publicKey, name) {
    try {
      await store.renameWallet(publicKey, name)
    } catch (e) {
      console.warn('wallet rename failed:', e)
    }
  }

  // --- delete ---
  const pendingDelete = ref({})

  async function deleteWallet(publicKey) {
    const pk = String(publicKey || '').trim()
    if (!pk) return
    if (pendingDelete.value[pk]) return

    const ok = window.confirm('Remove this wallet from console? Funds on-chain stay untouched.')
    if (!ok) return

    pendingDelete.value = { ...pendingDelete.value, [pk]: true }
    errMsg.value = ''

    try {
      await store.deleteWallet(pk)
    } catch (e) {
      errMsg.value = e?.message || 'wallet_remove_failed'
    } finally {
      const { [pk]: _, ...rest } = pendingDelete.value
      pendingDelete.value = rest
    }
  }

  // --- import modal + api ---
  const importBusy = ref({})
  const importModalOpen = ref(false)
  const importPk = ref('')
  const importPriv = ref('')
  const importError = ref('')

  async function openImport(publicKey) {
    const pk = String(publicKey || '').trim()
    if (!pk) return
    if (importBusy.value[pk]) return

    importError.value = ''
    importPk.value = pk
    importPriv.value = ''
    importModalOpen.value = true

    importBusy.value = { ...importBusy.value, [pk]: true }
    try {
      const res = await store.importWallet(pk)
      importPk.value = res.public_key || pk
      importPriv.value = res.private_key || ''
    } catch (e) {
      importError.value = e?.message || 'wallet_import_failed'
    } finally {
      const { [pk]: _, ...rest } = importBusy.value
      importBusy.value = rest
    }
  }

  function closeImport() {
    importModalOpen.value = false
    importPk.value = ''
    importPriv.value = ''
    importError.value = ''
  }

  // --- drag ---
  function onDragStart(publicKey, evt) {
    const pk = String(publicKey || '').trim()
    if (!evt?.dataTransfer || !pk) return
    evt.dataTransfer.effectAllowed = 'move'
    evt.dataTransfer.setData('text/plain', pk)
  }

  return {
    showCreate, busyCreate, errMsg,
    toggleCreate, cancelCreate, createWallet,
    renameWallet,
    pendingDelete, deleteWallet,
    importBusy, importModalOpen, importPk, importPriv, importError,
    openImport, closeImport,
    onDragStart,
  }
}
